import { render, staticRenderFns } from "./salaries_graph.vue?vue&type=template&id=8f777e1e&scoped=true&lang=pug&"
import script from "./salaries_graph.vue?vue&type=script&lang=coffee&"
export * from "./salaries_graph.vue?vue&type=script&lang=coffee&"
import style0 from "./salaries_graph.vue?vue&type=style&index=0&id=8f777e1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f777e1e",
  null
  
)

export default component.exports